module.exports = __webpack_public_path__ + "img/fox_logo.6893491.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/media/fox_logo.svg
// module id = ./assets/img/media/fox_logo.svg
// module chunks = 0 12